var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.8,11.6c-.4-.2-.8-.4-1.2-.5-.2,0-.5-.2-.6-.4-.4-.3-.3-.8.1-1,.1,0,.3,0,.4,0,.5,0,1,0,1.5.3.2.1.3,0,.4-.2,0-.3.2-.5.2-.8,0-.2,0-.3-.2-.4-.3-.1-.6-.2-.9-.3-.4,0-.4,0-.4-.5q0-.6-.6-.6c0,0-.2,0-.3,0-.3,0-.3,0-.3.3,0,.1,0,.3,0,.4,0,.4,0,.4-.4.5-.9.3-1.4.9-1.5,1.9,0,.8.4,1.4,1.1,1.8.4.3.9.4,1.4.6.2,0,.3.2.5.3.4.4.4,1-.2,1.2-.3.1-.6.2-.9.1-.5,0-.9-.2-1.3-.4-.2-.1-.3,0-.4.2,0,.2-.1.5-.2.7,0,.3,0,.4.2.5.4.2.8.3,1.2.3.3,0,.3,0,.3.4,0,.2,0,.3,0,.5,0,.2,0,.3.3.3.2,0,.4,0,.7,0,.2,0,.3-.1.3-.3s0-.4,0-.6c0-.2,0-.3.3-.4.5-.1.9-.4,1.2-.8.9-1,.5-2.6-.7-3.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.7,12c0,3.9-3.2,7.1-7.2,7.1s-7.1-3.2-7.1-7.1,3.2-7.1,7.1-7.1,3,.5,4.2,1.3l-1.2,1.5h4.2s-.5-4.7-.5-4.7l-1.4,1.8c-1.5-1.1-3.3-1.7-5.2-1.7C7.6,3.2,3.6,7.1,3.6,12s4,8.8,8.9,8.8,8.8-4,8.8-8.8h-1.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewPayment);
export default __webpack_public_path__ + "static/media/renew-payment.890cd2307efae929d3e6c4245f1d4a07.svg";
export { ForwardRef as ReactComponent };